import template from "./pPasswordReset.html";

export function pPasswordResetDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pPasswordResetController,
    controllerAs: 'pPasswordReset',
    bindToController: true
  };

  return directive;
}

class pPasswordResetController {
  constructor ($interval, $scope, $location, $routeParams, Auth, Bundle, Notes, ConnectionQuality) {
    'ngInject';
    this.$location = $location;
    this.$routeParams = $routeParams;
    this.Auth = Auth;
    this.Bundle = Bundle;
    this.ConnectionQuality = ConnectionQuality;
    this.Notes = Notes;
    this.newPassword = "";

    if($routeParams.passwordToken) {
      this.state = "set-password-form";
    } else {
      this.state = "send-link-form";
    }

    this.timeout = $interval(() => {
      this.notes = Notes.getNotes();
    }, 10);

    $scope.$on("$destroy", () => {
      $interval.cancel( this.timeout );
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  sendLink() {
    this.state = "sending-link";
    this.Auth.sendPasswordResetLink(this.email).then(() => {
      this.state = "send-link-success";
    }, (error) => {
      this.state = "send-link-error";
      this.error = error;
    });
  }

  setNewPassword() {
    this.state = "setting-password";
    this.Auth.setNewPassword(this.$routeParams.passwordToken, this.newPassword).then(() => {
      this.$location.path("/login");
    }, (error) => {
      this.state = "set-password-error";
      this.error = error;
    });
  }
}
